//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
export default {
  name: 'PermissionDataRuleModal',
  data: function data() {
    return {
      queryParam: {},
      title: '操作',
      visible: false,
      model: {},
      ruleConditionList: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      permissionId: '',
      validatorRules: {
        ruleConditions: {
          rules: [{
            required: true,
            message: '请选择条件!'
          }]
        },
        ruleName: {
          rules: [{
            required: true,
            message: '请输入规则名称!'
          }]
        },
        ruleValue: {
          rules: [{
            required: true,
            message: '请输入规则值!'
          }]
        },
        ruleColumn: {
          rules: []
        }
      },
      url: {
        list: '/sys/dictItem/list',
        add: '/sys/permission/addPermissionRule',
        edit: '/sys/permission/editPermissionRule'
      },
      showRuleColumn: true
    };
  },
  created: function created() {},
  methods: {
    add: function add(permId) {
      this.permissionId = permId;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);

      if (record.permissionId) {
        this.model.permissionId = record.permissionId;
      } else {
        this.model.permissionId = this.permissionId;
      }

      this.visible = true;
      this.initRuleCondition();
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'status', 'ruleName', 'ruleColumn', 'ruleConditions', 'ruleValue'));
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this2.model.id) {
            httpurl += _this2.url.add;
            method = 'post';
          } else {
            httpurl += _this2.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this2.model, values);

          if (formData.ruleColumn && formData.ruleColumn.length > 0) {
            formData.ruleColumn = formData.ruleColumn.trim();
          }

          if (formData.ruleValue && formData.ruleValue.length > 0) {
            formData.ruleValue = formData.ruleValue.trim();
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    initRuleCondition: function initRuleCondition() {
      if (this.model.ruleConditions && this.model.ruleConditions == 'USE_SQL_RULES') {
        this.showRuleColumn = false;
      } else {
        this.showRuleColumn = true;
      }
    },
    handleChangeRuleCondition: function handleChangeRuleCondition(val) {
      if (val == 'USE_SQL_RULES') {
        this.form.setFieldsValue({
          ruleColumn: ''
        });
        this.showRuleColumn = false;
      } else {
        this.showRuleColumn = true;
      }
    }
  }
};